import { styled } from '@arpeggi/ui'
import { ComponentProps, FC } from 'react'
import { CaretHorizontal, ChevronDown, ChevronUp } from '../../core/icons'

const Wrapper = styled('div', {
  flex: '2',
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  cursor: 'pointer'
})

const DownIcon = styled(ChevronDown, { width: '12px', height: '12px' })
const UpIcon = styled(ChevronUp, { width: '12px', height: '12px' })

interface Props {
  orderByKey: string
  orderByValue: string
  order: string
  title: string
}

export const SortableTableHeader: FC<Props & ComponentProps<typeof Wrapper>> = ({
  orderByValue,
  orderByKey,
  order,
  title,
  ...rest
}) => {
  return (
    <Wrapper {...rest}>
      {title}
      {orderByValue === orderByKey && order === 'desc' && <DownIcon />}
      {orderByValue === orderByKey && order === 'asc' && <UpIcon />}
      {orderByValue !== orderByKey && (
        <CaretHorizontal style={{ transform: 'rotate(90deg)', width: '12px', height: '12px' }} />
      )}
    </Wrapper>
  )
}
